"use strict";

PF.FloatingPicker = class FloatingPicker extends PF.Widget
	{
	static get options()
		{
		return {
			dom: {
				pickerContainer: undefined,
				content: undefined,
				touchArea: undefined
			},
			html: PF.FloatingPicker.templates,
			steps: [
				'0px', '100px', '65%', '100%'
			],
			trackHeight: false,
			touchTimeLimit: 250,
			animTime: 150,
		};
		}

	static get templates()
		{
		return {
			picker: `
				<div class="pf-floating-picker move" style="border-left: 1px solid #DBDBDB; border-right:1px solid #DBDBDB; width: calc(100% - 2px);">					
				</div>
				`
		};
		}

	init()
		{
		this.dom.loads(this.html);

		this.dom.pickerContainer.append(this.dom.picker);
		this.dom.picker.append(this.dom.content);

		if (this.dom.touchArea !== undefined)
			{
			// this.dom.touchArea.on('touchstart', this.touchStart.bind(this));

			this.dom.touchArea.on('mousedown.listDnd', (event) => {
				event.preventDefault();
				this.start(event);
				$(document).on('mousemove.listDnd', (event) => {
					this.drag(event);
					this.drag(event);
				});
				$(document).on('mouseup.listDnd', (event) => {
					this.stop();
					$(document).off('mousemove.listDnd');
					$(document).off('mouseup.listDnd');
				});
			});

			this.dom.touchArea.on('touchstart.listDnd', (event) => {
				if (event.originalEvent.touches.length === 1)
					{
					this.start({clientX: event.originalEvent.touches[0].pageX, clientY: event.originalEvent.touches[0].pageY,});
					this.dom.touchArea.on('touchmove.listDnd', (event) => {
						if (event.originalEvent.touches.length === 1)
							{
							event.preventDefault();
							this.drag({clientX: event.originalEvent.touches[0].pageX, clientY: event.originalEvent.touches[0].pageY,});
							}
					});
					this.dom.touchArea.on('touchend.listDnd', (event) => {
						this.stop();
						this.dom.touchArea.off('touchmove.listDnd');
						this.dom.touchArea.off('touchend.listDnd');
					});
					}
			});


			}

		if (this.trackHeight)
			{
			this.heightObserver = new PF.HeightObserver(this.dom.content, this.heightChangeSlot.bind(this));
			this.heightObserver.start();
			}

		}

	destroy()
		{
		this.dom.picker.remove();
		}

	heightChangeSlot()
		{
		console.log('heightChangeSlot');
		if (this.dom.picker.height() < this.dom.content.height())
			{
			let newHeight = Math.min(this.dom.content.height(), this.dom.pickerContainer.height());
			this.setHeight(newHeight);
			}
		}

	open(stepIndex)
		{
		this.dom.picker.show();
		this.setStep(stepIndex);
		}

	close()
		{
		this.setHeight(0);
		setTimeout(() => this.dom.picker.hide(), this.animTime);
		}

	// touchStart(event)
	// 	{
	// 	if (event.originalEvent.touches.length === 1)
	// 		{
	// 		this.dom.picker.removeClass('move');
	// 		if (this.trackHeight)
	// 			{
	// 			this.heightObserver.stop();
	// 			}
	// 		event.preventDefault();
	// 		$("body").addClass("not-selectable");
	// 		this.dom.pickerContainer.on('touchmove.pf-floating-picker', this.touchMove.bind(this));
	// 		this.dom.pickerContainer.on('touchend.pf-floating-picker', this.touchEnd.bind(this));
	//
	// 		this.dom.picker.addClass('touch');
	//
	//
	// 		this.y1 = event.originalEvent.touches[0].pageY;
	// 		this.h1 = this.dom.picker.height();
	//
	// 		this.startTime = (new Date()).getTime();
	//
	// 		this.resultMove = -5;
	// 		}
	// 	}
	//
	// touchMove(event)
	// 	{
	// 	this.move = true;
	// 	if (event.originalEvent.touches.length === 1)
	// 		{
	// 		// event.preventDefault();
	// 		let y2 = event.originalEvent.touches[0].pageY;
	// 		let h2 = this.h1 - y2 + this.y1;
	//
	// 		h2 = Math.max(h2, 0);
	// 		h2 = Math.min(h2, this.dom.pickerContainer.height());
	//
	// 		this.dom.picker.height(h2);
	//
	// 		this.resultMove += y2 - this.y1;
	//
	// 		this.h1 = h2;
	// 		this.y1 = y2;
	// 		}
	// 	}
	//
	// touchEnd(event)
	// 	{
	// 	// if()
	// 	this.dom.pickerContainer.off('touchmove.pf-floating-picker');
	// 	this.dom.pickerContainer.off('touchend.pf-floating-picker');
	//
	// 	this.dom.picker.removeClass('touch');
	//
	// 	$("body").removeClass("not-selectable");
	//
	// 	this.endTime = (new Date()).getTime();
	// 	this.touchTime = this.endTime - this.startTime;
	//
	// 	if (this.touchTime < this.touchTimeLimit && this.touchTime > 50)
	// 		{
	// 		let index = this.getStepByDirection(this.resultMove);
	// 		if (this.isIndexValid(index))
	// 			{
	// 			this.setStep(index);
	// 			}
	// 		}
	// 	else
	// 		{
	// 		let index = this.getStepByClosest(this.dom.picker.height());
	// 		if (this.isIndexValid(index))
	// 			{
	// 			this.setStep(index);
	// 			}
	// 		}
	// 	if (this.trackHeight)
	// 		{
	// 		this.heightObserver.start();
	// 		}
	// 	this.dom.picker.addClass('move');
	// 	}

	start(event)
		{
		// if (event.originalEvent.touches.length === 1)
			{
			this.dom.picker.removeClass('move');
			if (this.trackHeight)
				{
				this.heightObserver.stop();
				}
			// event.preventDefault();
			$("body").addClass("not-selectable");
			// this.dom.pickerContainer.on('touchmove.pf-floating-picker', this.touchMove.bind(this));
			// this.dom.pickerContainer.on('touchend.pf-floating-picker', this.touchEnd.bind(this));

			this.dom.picker.addClass('touch');


			this.y1 = event.clientY;
			this.h1 = this.dom.picker.height();

			this.startTime = (new Date()).getTime();

			this.resultMove = -5;
			}
		}

	drag(event)
		{
		this.move = true;
		// if (event.originalEvent.touches.length === 1)
			{
			// event.preventDefault();
			let y2 = event.clientY;
			let h2 = this.h1 - y2 + this.y1;

			h2 = Math.max(h2, 0);
			h2 = Math.min(h2, this.dom.pickerContainer.height());

			this.dom.picker.height(h2);

			this.resultMove += y2 - this.y1;

			this.h1 = h2;
			this.y1 = y2;
			}
		}

	stop(event)
		{
		// if()
		this.dom.pickerContainer.off('touchmove.pf-floating-picker');
		this.dom.pickerContainer.off('touchend.pf-floating-picker');

		this.dom.picker.removeClass('touch');

		$("body").removeClass("not-selectable");

		this.endTime = (new Date()).getTime();
		this.touchTime = this.endTime - this.startTime;

		if (this.touchTime < this.touchTimeLimit && this.touchTime > 50)
			{
			let index = this.getStepByDirection(this.resultMove);
			if (this.isIndexValid(index))
				{
				this.setStep(index);
				}
			}
		else
			{
			let index = this.getStepByClosest(this.dom.picker.height());
			if (this.isIndexValid(index))
				{
				this.setStep(index);
				}
			}
		if (this.trackHeight)
			{
			this.heightObserver.start();
			}
		this.dom.picker.addClass('move');
		}

	isIndexValid(index)
		{
		return index >= 0 && index < this.steps.length;
		}

	setStep(index)
		{
		this.setHeight(this.getStepHeight(index));
		this.currentStep = index;
		}

	setHeight(height)
		{
		if (this.trackHeight)
			{
			this.heightObserver.stop();
			}

		// this.dom.picker.addClass('move');
		this.dom.picker.height(height);
		if (this.trackHeight)
			{
			setTimeout(() => this.heightObserver.start());
			}
		}

	getStepHeight(index)
		{
		let str = this.steps[index];
		if (str.endsWith('px'))
			{
			return parseInt(str);
			}
		if (str.endsWith('%'))
			{
			return parseInt(str) / 100 * this.dom.pickerContainer.height();
			}
		// if(str === 'contentHeight')
		// 	{
		// 	return this.dom.content.height();
		// 	}
		}


	getStepByDirection(direction)
		{
		let k = direction < 0 ? 1 : -1;
		let stepIndex = this.currentStep + k;
		stepIndex = Math.max(stepIndex, 0);
		stepIndex = Math.min(stepIndex, this.steps.length);
		return stepIndex;
		}

	getStepByClosest(height)
		{
		let min = Infinity;
		let minStepIndex = undefined;
		for (let i = 0; i < this.steps.length; i++)
			{
			let delta = Math.abs(height - this.getStepHeight(i));
			if (min > delta)
				{
				min = delta;
				minStepIndex = i;
				}
			}
		return minStepIndex;
		}
	};


